import { apiClient } from '../client';
import { API_ENDPOINTS, CACHE_CONFIG } from '../config';

interface ClaimsListParams {
  status?: 'all' | 'pending' | 'approved' | 'denied';
  dateRange?: string;
  page?: number;
  limit?: number;
}

interface DisputeData {
  reason: string;
  description: string;
  attachments?: File[];
}

class ClaimsService {
  async getClaimsList(params?: ClaimsListParams) {
    const queryParams = new URLSearchParams();
    if (params) {
      Object.entries(params).forEach(([key, value]) => {
        if (value !== undefined) {
          queryParams.append(key, value.toString());
        }
      });
    }

    return apiClient.get(`${API_ENDPOINTS.claims.list}?${queryParams}`, {
      cacheTTL: CACHE_CONFIG.defaultTTL
    });
  }

  async getClaimsSummary() {
    return apiClient.get(API_ENDPOINTS.claims.summary, {
      cacheTTL: CACHE_CONFIG.defaultTTL
    });
  }

  async getClaimDetail(claimId: string) {
    return apiClient.get(API_ENDPOINTS.claims.detail(claimId), {
      cacheTTL: CACHE_CONFIG.defaultTTL
    });
  }

  async disputeClaim(claimId: string, data: DisputeData) {
    const formData = new FormData();
    formData.append('reason', data.reason);
    formData.append('description', data.description);
    
    if (data.attachments) {
      data.attachments.forEach((file, index) => {
        formData.append(`attachment_${index}`, file);
      });
    }

    const response = await apiClient.upload(API_ENDPOINTS.claims.dispute(claimId), formData);
    
    // Clear claims cache
    apiClient.clearCache(API_ENDPOINTS.claims.list);
    apiClient.clearCache(API_ENDPOINTS.claims.detail(claimId));
    
    return response;
  }
}

export const claimsService = new ClaimsService();